<template>
  <b-modal
    id="select-event-modal"
    ok-only
    modal-class="modal-doom-yoga"
    centered
    hide-footer
  >
    <template #modal-title> Select Event </template>


    <b-form @submit.prevent="onSubmit">
        
    <EventsCalendarList :select_event="true" />
      <b-row class="justify-content-center w-100 mt-5">
        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="submit"
            variant="doomyoga-primary"
            class="w-100 btn-bumblebee btn-doomyoga btn-doomyoga-submit"
            v-if="!is_loading"
          >
            Save
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="doomyoga-danger-outline"
            class="w-100 btn-bumblebee btn-doomyoga btn-doomyoga-submit"
            @click="closeModal('select-event-modal')"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import EventsCalendarList from "@/components/events/CalendarList.vue";

export default {
  name: "SelectEventModal",
  components: { EventsCalendarList },
  props: ["user_id"],
  data() {
    return {
      is_loading: false,
      sms_title: null,
      sms_context: null,
      send_to: null,
      invalid_send_to: false,
      send_to_options: [
        { label: "Select event", code: "event" },
        { label: "Members only", code: "members" },
        { label: "All users", code: "all_users" },
      ],
    };
  },
  mounted() {
    // console.log(this.$parent)
  },
  watch: {
    send_to(newval, oldval) {
      console.log(newval, oldval);
      if (newval == "event") {
        this.$root.$emit("bv::show::modal", "select-event-modal");
      }
    },
  },
  methods: {
    closeModal(id) {
      this.$bvModal.hide(id);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SMS/SelectEventModal.vue